import React from "react"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapPin, faCommentDots } from '@fortawesome/free-solid-svg-icons'


class ProfileTeaser extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      nativeLanguages: [],
      loaded:false
    }

    this.renderNativeLanguages = this.renderNativeLanguages.bind(this)
  }

  renderNativeLanguages() {
    const length = this.state.nativeLanguages.length
    return this.state.nativeLanguages.map((lu, i) => {
        return `${lu.language.native}${i+1 === length ? '' : ', '}`
    })
  }


  componentDidMount() {

    this.setState({
      nativeLanguages: this.props.match.languages_users.filter(lang => lang.level === 5),
      loaded: true
    })
  }

  render() {
    const { avatar_url } = this.props.match
    if(this.state.loaded != true) {
      return null
    }
    return(
      <div className="profile_teaser_container">
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly'}}>
          <img
            src={avatar_url.includes('missing') ? this.props.missingImg : avatar_url}
            style={{height: 170, width: 170, cursor: 'pointer', borderRadius: 10}}
            onClick={() => window.location.replace(`/profile/${this.props.match.slug}`)}
            />
          <div
            style={{
              textAlign: 'left',
              marginLeft: 10,
              display: 'flex',
              flexDirection: 'column',
              height: 170,
              width: 250,
              justifyContent: 'space-between'
            }}>
            <h3 style={{fontWeight: 600, marginBottom: 5, color: '#151E25'}}>{this.props.match.preferred_name}</h3>
            <div style={{alignItems: 'center', display: 'flex'}}>
              <FontAwesomeIcon
                icon={faCommentDots}
                style={{fontSize: 18, color: '#151E25', marginRight: 10}}
              />
              <h4 style={{color: '#151E25'}}>{this.renderNativeLanguages()}</h4>
            </div>
            <div style={{alignItems: 'center', display: 'flex'}}>
              <FontAwesomeIcon
                icon={faMapPin}
                style={{fontSize: 18, color: '#151E25', marginRight: 16}}
              />
              <h4 style={{color: '#151E25'}}>{this.props.match.location}</h4>
            </div>
            {this.props.match.bio != null &&
            <div style={{alignItems: 'center', display: 'flex'}}>
              <h4 style={{color: '#151E25', fontWeight: 200}}>{this.props.match.bio.length > 55 ? `${this.props.match.bio.substring(0, 55)}...` : this.props.match.bio}</h4>
            </div>}
            <button
              onClick={() => window.location.replace(`/profile/${this.props.match.slug}`)}
              className="button_primary">{`View profile`}</button>
          </div>

        </div>
      </div>
    )
  }
}

// {(this.props.match.bio != null && this.props.match.bio.length > 5) && <h4 style={{padding: '10%'}}>"{this.props.match.bio}"</h4>}



export default ProfileTeaser;
